import React, { createContext, useContext, useState, useCallback } from 'react';

const CreateAdContext = createContext(null);

export const CreateAdProvider = ({ children }) => {
  const [pendingActions, setPendingActions] = useState([]);
  const [submitSignal, setSubmitSignal] = useState(0);

  const dispatchActions = useCallback((actions) => {
    if (Array.isArray(actions) && actions.length > 0) {
      setPendingActions([...actions]);
    }
  }, []);

  const clearActions = useCallback(() => {
    setPendingActions([]);
  }, []);

  const requestSubmit = useCallback(() => {
    setSubmitSignal((s) => s + 1);
  }, []);

  return (
    <CreateAdContext.Provider value={{ pendingActions, dispatchActions, clearActions, submitSignal, requestSubmit }}>
      {children}
    </CreateAdContext.Provider>
  );
};

const NO_OP_CTX = {
  pendingActions: [],
  dispatchActions: () => {},
  clearActions: () => {},
  submitSignal: 0,
  requestSubmit: () => {},
};

export const useCreateAdContext = () => {
  return useContext(CreateAdContext) || NO_OP_CTX;
};

export default CreateAdContext;
